import { useState } from 'react';
import * as Api from '../../api/Api';
import AddUser from './add-user';
import { Unauthorized } from '../Global/unauthorized';
import PermissionsGate from '../../../app/api/PermissionsGate';
import { SCOPES } from '../../../app/config/permissions-map';
import { PageTitle } from '../../../_metronic/layout/core'
import EditUser from './edit-user';
import { useGetRoleList, useGetToken } from '../../Hooks/CustomHooks';
import AgTable from '../../Components/Table/AgTable';

export default function ListUser({ title }) {
    const [showAddUser, setShowAddUser] = useState(false);
    const [showEditUser, setShowEditUser] = useState(false);
    const [userEdit, setUserEdit] = useState({});
    const [refreshTable, setRefreshTable] = useState(true); //this helps EditUser and AddUser refresh table and reflect changes

    let roleList = useGetRoleList();

    let token = useGetToken();

    const openEditModal = (data) => {
        setUserEdit(data);
        setShowEditUser(true);
    }
    const header = [
        {
            headerName: 'Nombre Completo',
            field: 'name',
            cellRenderer: (props) => (
                <div className="align-items-center d-flex h-100 justify-content-center">
                    <span value={props.data.name} className="text-gray-800 mb-1 nombre-user">{props.data.name}</span>
                </div>
            )
        },
        {
            headerName: 'Correo Electrónico',
            field: 'email',
        },
        {
            headerName: 'Estado',
            field: 'userState',
            cellRenderer: (props) => (
                props.data.userState
                    ? <div className="badge badge-light-success fw-bolder text-capitalize">Activo</div>
                    : <div className="badge text-capitalize badge-light-danger fw-bolder">Bloqueado</div>
            )
        },
        {
            headerName: 'Editar',
            cellRenderer: (props) => (
                <button onClick={() => { openEditModal(props.data) }} className="btn btn-light btn-active-light-primary btn-smn">
                    <i className="fi-rr-settings"></i>
                </button>
            )
        }
    ]

    const handleAddUser = () => {
        setShowAddUser(true)
    }

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.GESTION_USUARIOS]} >
                <PageTitle>{title}</PageTitle>

                <div className="card my-5">
                    <div className="card-header border-0 pt-6">
                        <div className="card-toolbar">
                            <div className="d-flex justify-content-end">
                                <button className="btn btn-sm btn-primary btn-active-primary" onClick={handleAddUser}>
                                    <span className="svg-icon svg-icon-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <rect opacity="0.5" x="11.364" y="20.364" width="16" height="2" rx="1" transform="rotate(-90 11.364 20.364)" fill="black"></rect>
                                            <rect x="4.36396" y="11.364" width="16" height="2" rx="1" fill="black"></rect>
                                        </svg>
                                    </span>
                                    Añadir Usuario
                                </button>
                                {showAddUser &&
                                    <AddUser setShowAddUser={setShowAddUser} showAddUser={showAddUser} setRefreshData={setRefreshTable} />
                                }
                                {showEditUser &&
                                    <EditUser userEdit={userEdit} setUserEdit={setUserEdit} setShowEditUser={setShowEditUser} showEditUser={showEditUser} setRefreshData={setRefreshTable} />
                                }

                            </div>
                        </div>
                    </div>
                    <div className="card-body tab-content pt-0">
                        <AgTable
                            idContent={"usersTable"}
                            apiService={Api.getUsersList}
                            setAuxData={null}
                            header={header}
                            titleExcel={"Usuarios"}
                            conditions={refreshTable}
                            args={{ roleList: roleList, token: token }}
                            hideFilter={false}
                            paginationPageSize={8}
                            rowHeight={40}
                            updateCondition={setRefreshTable}
                        />
                    </div>
                </div>

            </PermissionsGate>
        </>
    )
}